import { render, staticRenderFns } from "./platformCityManagement.vue?vue&type=template&id=24a06679&scoped=true&"
import script from "./platformCityManagement.vue?vue&type=script&lang=js&"
export * from "./platformCityManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformCityManagement.vue?vue&type=style&index=0&id=24a06679&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a06679",
  null
  
)

export default component.exports